import { useEffect, useState } from "react";
import { getConsent } from "@/lib/tracking";

const BASE_URL = process.env.REACT_APP_CHATWOOT_BASE_URL;
const WEBSITE_TOKEN = process.env.REACT_APP_CHATWOOT_WEBSITE_TOKEN;

function loadChatwoot() {
    if (!BASE_URL || !WEBSITE_TOKEN) return;
    if (document.getElementById("chatwoot-sdk")) return;

    window.chatwootSettings = { position: "left", type: "standard" };
    const script = document.createElement("script");
    script.id = "chatwoot-sdk";
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
        window.chatwootSDK?.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
    };
    document.body.appendChild(script);
}

export default function Chatwoot() {
    const [, setConsentVersion] = useState(0);

    useEffect(() => {
        if (getConsent() === "accepted") loadChatwoot();
        const onConsentChange = () => setConsentVersion((v) => v + 1);
        window.addEventListener("cbz:consent-change", onConsentChange);
        return () => window.removeEventListener("cbz:consent-change", onConsentChange);
    }, []);

    useEffect(() => {
        if (getConsent() === "accepted") loadChatwoot();
    });

    return null;
}
